import script from "./ProveEmmanuele.vue?vue&type=script&lang=js"
export * from "./ProveEmmanuele.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__